import type { ReactNode } from "react";

export function QuotesPrimaryText(props: {
  children: ReactNode;
  bold?: boolean | undefined;
}) {
  return (
    <div
      className={`text-[18px] ${props.bold ? "font-bold" : "font-medium"} text-foreground`}
    >
      {props.children}
    </div>
  );
}
